import { MarkdownContent } from 'elements/visual/MarkdownContent';
import { DetailQuery_moment_cards_TextCard } from 'graphql/query/__generated__/DetailQuery';
import { EColors2, EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    card: DetailQuery_moment_cards_TextCard;
    className?: string;
}

export const TextCard = (props: Props): JSX.Element => {
    const info = props.card.info;

    return (
        <S_TextCard className={props.className}>
            {info.title && <S_Title>{info.title}</S_Title>}
            {info.title && info.description && <S_Split />}
            {info.description && <S_Text text={info.description} />}
        </S_TextCard>
    );
};

const S_TextCard = styled.div`
    display: flex;
    flex-direction: column;
`;

const S_Title = styled.div`
    font-size: 18px;
    line-height: 20px;
    color: ${EColors2.DARK};
    font-family: ${EFonts.Bold};
`;

const S_Text = styled(MarkdownContent)``;

const S_Split = styled.div`
    width: 100%;
    height: 10px;
`;
